class MoochReviews extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-reviews-track]');
    if (!this.track) return;

    this.cards = [...this.track.querySelectorAll('[data-reviews-card]')];
    if (this.cards.length === 0) return;

    this.prevBtn = this.querySelector('[data-reviews-prev]');
    this.nextBtn = this.querySelector('[data-reviews-next]');
    this.dotsWrap = this.querySelector('[data-reviews-dots]');
    this.currentIndex = 0;

    this.prevBtn?.addEventListener('click', () => this.slide(-1));
    this.nextBtn?.addEventListener('click', () => this.slide(1));

    this.initTouch();
    this.initDots();
    this.updateState();

    window.addEventListener('resize', () => this.updateState());
  }

  getVisibleCount() {
    const containerWidth = this.track.offsetWidth;
    if (containerWidth >= 1024) return 4;
    if (containerWidth >= 768) return 3;
    if (containerWidth >= 475) return 2;
    return 1;
  }

  getMaxIndex() {
    const visible = this.getVisibleCount();
    return Math.max(0, this.cards.length - visible);
  }

  slide(direction) {
    const maxIndex = this.getMaxIndex();
    this.currentIndex = Math.max(0, Math.min(this.currentIndex + direction, maxIndex));
    this.updateState();
  }

  goTo(index) {
    this.currentIndex = Math.max(0, Math.min(index, this.getMaxIndex()));
    this.updateState();
  }

  updateState() {
    const visible = this.getVisibleCount();
    const gap = 12;
    const cardWidth = (this.track.offsetWidth - gap * (visible - 1)) / visible;
    const offset = this.currentIndex * (cardWidth + gap);

    this.track.style.transform = `translateX(-${offset}px)`;

    if (this.prevBtn) {
      this.prevBtn.classList.toggle('mooch-reviews__arrow--hidden', this.currentIndex === 0);
    }
    if (this.nextBtn) {
      this.nextBtn.classList.toggle('mooch-reviews__arrow--hidden', this.currentIndex >= this.getMaxIndex());
    }

    this.updateDots();
  }

  initDots() {
    if (!this.dotsWrap) return;
    this.renderDots();
  }

  renderDots() {
    if (!this.dotsWrap) return;
    const maxIndex = this.getMaxIndex();
    this.dotsWrap.innerHTML = '';

    for (let i = 0; i <= maxIndex; i++) {
      const dot = document.createElement('button');
      dot.className = 'mooch-reviews__dot';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      if (i === this.currentIndex) {
        dot.classList.add('mooch-reviews__dot--active');
      }
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
    }
  }

  updateDots() {
    if (!this.dotsWrap) return;
    const maxIndex = this.getMaxIndex();
    const dots = this.dotsWrap.querySelectorAll('.mooch-reviews__dot');

    if (dots.length !== maxIndex + 1) {
      this.renderDots();
      return;
    }

    dots.forEach((dot, i) => {
      dot.classList.toggle('mooch-reviews__dot--active', i === this.currentIndex);
    });
  }

  initTouch() {
    let startX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        this.slide(diff > 0 ? 1 : -1);
      }
    }, { passive: true });
  }
}

if (!customElements.get('mooch-reviews')) {
  customElements.define('mooch-reviews', MoochReviews);
}
